import request from '@/utils/request'

export function getGoodsList (params) {
    return request({
        url: 'goods/list',
        method: 'get',
        params
    })
}

export function getGoodsDetail (data) {
  return request({
    url: 'goods/detail',
    method: 'get',
    params: data
  })
}
